import { captureException } from "@sentry/vue";

import { type PushNotificationStore, usePushNotificationsStore } from "../Store";

import PushNotificationsAPIConnector from "@/Services/TherapyApi/PushNotifications";

import { danger } from "@/Utils/Debug";
import { isAndroidApp } from "@/Utils/Ionic";
import { PUSH_PLATFORM } from "../Models/constants";
import { hasValue } from "@/Utils/Objects";

class UpdatePushTokenActionHandler {
  constructor(
    private readonly pushStore: PushNotificationStore = usePushNotificationsStore(),
    private readonly pushApi = new PushNotificationsAPIConnector()
  ) {}

  public async handle(token: string, enable: boolean = false): Promise<string | undefined> {
    this.pushStore.token = token;
    this.pushStore.isAvailable = enable;

    try {
      const response = await this.pushApi.updateToken(
        token,
        isAndroidApp() ? PUSH_PLATFORM.ANDROID : PUSH_PLATFORM.IOS,
        enable
      );

      if (hasValue(response)) {
        return response.pushtoken;
      } else {
        this.pushStore.isAvailable = false;

        return undefined;
      }
    } catch (e) {
      this.pushStore.isAvailable = false;

      danger("Error updating push token");
      captureException(e);

      return undefined;
    }
  }
}

export default UpdatePushTokenActionHandler;
